const SAFE_PROTOCOLS = new Set(['http:', 'https:', 'mailto:', 'tel:']);

export const sanitizeNavigationHref = (rawHref, fallback = '#') => {
  const value = String(rawHref || '').trim();
  if (!value) return fallback;

  if (value.startsWith('#')) return value;
  if (value.startsWith('/')) return value;

  try {
    const parsed = new URL(value, window.location.origin);
    if (!SAFE_PROTOCOLS.has(parsed.protocol)) return fallback;
    return parsed.href;
  } catch (_) {
    return fallback;
  }
};
